import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Base64 } from 'js-base64';
import { WhitelabelConfigStore } from '../core/config/whitelabel-config.store';
import { configuredRouteLandings, RouteLanding } from '../core/seo/route-landing';
import { DataService } from '../services';

@Component({
  selector: 'app-route-landing',
  templateUrl: './route-landing.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RouteLandingComponent implements OnInit, OnDestroy {
  landing: RouteLanding | null = null;
  private routeSubscription?: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly dataService: DataService,
    public readonly configStore: WhitelabelConfigStore
  ) {}

  get operatorName(): string {
    return this.configStore.snapshot.config?.site.name || 'Mash Poa';
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.paramMap.subscribe(params => {
      const slug = params.get('slug');
      const slides = this.configStore.snapshot.config?.slides || [];
      this.landing = configuredRouteLandings(slides)
        .find(route => route.slug === slug) || null;
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
  }

  searchBuses(): void {
    if (!this.landing) {
      return;
    }

    const traveldate = formatDate(new Date(), 'yyyy-MM-dd', 'en-KE');
    const search = {
      pickup: this.landing.origin,
      dropoff: this.landing.destination,
      pickupname: this.landing.origin,
      dropoffname: this.landing.destination,
      traveldate,
      returndate: '',
      returning: false
    };
    const message = Base64.encode(JSON.stringify(search));
    this.dataService.changeMessage(message);
    this.router.navigate(['/booking', traveldate]);
  }
}
